import React, {Component} from 'react'
import CopyToClipboard from '../../../shared/CopyToClipboard'
import PropTypes from 'prop-types'

class ItemSideDefault extends Component {
    render() {
        const {side, url, orderId, type} = this.props

        return (
            <div className='ItemSideDefault border rounded bg-white'>
                <div className='px-2 py-1'>{side}</div>
                <div className='border-top'>
                    {
                        url &&
                        <a href={url} target='_blank' rel='noreferrer noopener'>
                            <span className='Icon View p-2' title='View'><i className='fa fa-eye'/></span>
                        </a>
                    }

                    {
                        url &&
                        <CopyToClipboard text={url} target={`copy_${type}_${side}_${orderId}`}>
                            <span className='Icon no-pointer-event p-2'><i className='fa fa-clone'/></span>
                        </CopyToClipboard>
                    }
                </div>
            </div>
        )
    }
}

ItemSideDefault.defaultProps = {
    url: '',
}

ItemSideDefault.propTypes = {
    side: PropTypes.string.isRequired,
    url: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['update-design', 'update-mock-up']),
}

export default ItemSideDefault
